import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { ISecDependenciaHistorico } from '../../../../shared/interfaces/database/seguridad';
import { HistoricoEventoService } from '../../../../services/database/historico-evento.service';

@Component({
  selector: 'app-admin-dependencias-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle],
  templateUrl: './admin-dependencias-historico.component.html',
  styleUrl: './admin-dependencias-historico.component.scss'
})
export class AdminDependenciasHistoricoComponent implements OnInit {

  title: string = 'Dependencia Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private _hes: HistoricoEventoService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      dependenciaHistorial: this._t.get('msg.dependenciaHistorial'),
      descripcion: this._t.get('common.descripcion'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion')
    }));
    this.title = this.trans.dependenciaHistorial;
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        }
      ]
    } as ICustomTable;

  }

  show(hojaDeVidaTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(hojaDeVidaTramiteId);
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(secDependenciaId: number) {
    this._hes.getSecDependenciaHistorico(secDependenciaId).subscribe({
      next: (data: ISecDependenciaHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._hes.getSecDependenciaHistoricoEliminado().subscribe({
      next: (data: ISecDependenciaHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
